import Image from "next/dist/client/image"
import styles from "./Card.module.scss";

const Card = (
  {src,index,children}:{src:StaticImageData, index:number,children:JSX.Element}) => (
  <article className={styles[`card_${index}`]}>
    <figure>
      <Image
        src={src}
        alt=""
      />
    </figure>
    <div className={styles.text}>
      {children}
    </div>
  </article>
)

export default Card